import { SamlIdentityProviderDto, SamlIdentityProvidersApi } from '../../../../api-client';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ErrorResponse } from '../../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../../common';

const QUERY_KEY = 'saml-providers';

type UseGetSamlProviders = (
  options?: UseQueryOptions<SamlIdentityProviderDto[], ErrorResponse, SamlIdentityProviderDto[], string[]>,
) => UseQueryResult<SamlIdentityProviderDto[]>;

export const useGetSamlProviders: UseGetSamlProviders = (options) => {
  const samlIdentityProvidersApi = new SamlIdentityProvidersApi(getApiConfiguration());
  const tenantId = localStorage.getItem('tenantId') as string;
  return useQuery(
    [QUERY_KEY],
    async () => samlIdentityProvidersApi.getSamlProviders(tenantId).then((res) => res.data),
    {
      ...options,
      retry: false,
      keepPreviousData: false
    }
  );
};
